<template functional>
    <font-awesome-icon
        v-if="props.value"
        :icon="['fal', 'check-square']"
        :size="props.size"
    />
    <font-awesome-icon
        v-else
        :icon="['fal', 'square']"
        :size="props.size"
    />
</template>

<script>
// possibly convert to function
export default {
    name: 'checkbox',

    props: {
        value: {
            type: Boolean,
            required: true,
        },

        // corresponds to FA sizes, xs sm lg 2x-10x
        size: {
            type: String,
            default: 'sm',
        },
    },
};
</script>
